// extracted by mini-css-extract-plugin
module.exports = {"outer":"outer___3_cq_","fixed":"fixed____mEDK"};